import i18n from "../plugins/i18n/i18n";
import {
  status,
  ticketStatus,
  billStatus,
  companyTypes,
  membershipTypes,
  feedbackScore,
} from "../helpers/constants";

const getFilters = (keyValuePairs, propName, type) => {
  let filters = [];
  if (keyValuePairs[propName]) {
    keyValuePairs[propName].map((item) => {
      if (propName === "name") {
        return filters.push({
          label: item.text,
          value: item.text,
        });
      } else {
        return filters.push({
          label: item.text,
          value: item.value,
        });
      }
    });
  } else if (propName === "feedbackScore") {
    filters = feedbackScore;
  } else if (propName === "status" && type === "invoiceExtract") {
    filters = billStatus;
  } else if (propName === "status") {
    filters = status;
  } else if (propName === "ticketStatus") {
    filters = ticketStatus;
  } else if (propName === "companyType") {
    filters = companyTypes;
  } else if (propName === "membershipType") {
    filters = membershipTypes;
  } else {
    filters = null;
  }

  return filters;
};

const isFilterable = (keyValuePairs, propName, type) => {
  let hasFilter;
  hasFilter = getFilters(keyValuePairs, propName) ? true : false;

  if (propName.includes("Date") || propName === "date") {
    hasFilter = true;
  }

  if (propName === "status" && type === "automaticPaymentList") {
    hasFilter = false;
  }
  if (propName === "feedbackScore" && type !== "allTicket") {
    hasFilter = false;
  }

  return hasFilter;
};

const getFilterType = (propName) => {
  if (propName.includes("Date") || propName === "date") {
    return "date";
  } else if (propName === "documentNumber" || propName === "unPaidAmount") {
    return "string";
  } else {
    return "select";
  }
};

const CreateColumnName = (key) => {
  if (key.includes("Id")) {
    if (!key.includes("Ids")) {
      key = key.substring(0, key.length - 2) + "Name";
    }
  }
  if (key.includes("Ids")) {
    key = key.substring(0, key.length - 3) + "Name";
  }
  return i18n.t(key, { lng: localStorage.getItem("i18nextLng").substr(0, 2) });
};

const createTableColumns = (type, dataList, keyValuePairs, exceptFor) => {

  let columns = [];

  let item = dataList[0];
  let keyList = [];
  if (item) {
    let keys = Object.keys(item);
    keys.map((key) => {
      if (!exceptFor.includes(key)) {
        if (key === "name" && type !== "company") {
          key = type + key.substr(0, 1).toUpperCase() + key.substr(1);
        }
        return keyList.push(key);
      }
      return null;
    });
  }

  const setWidth = (propName, type) => {

    if (propName === " ") {
      return 60;
    } else if (propName === "id") {
      return 80;
    } else if (
      propName === "edit" ||
      propName === "delete" ||
      propName === "color" ||
      propName === "icon" ||
      propName === "feedbackScore"
    ) {
      return 90;
    } 
    else if (type === "dailypass" && propName === "date") {
      return 170;
    }
    else if (type === "locationguest" && propName === "date") {
      return 170;
    } else if (
      (type === "ticket" || type === "allTicket") &&
      propName === "description"
    ) {
      return 100;
    } else if (
      (type !== "automaticPaymentList" && propName === "status") ||
      propName.includes("date")
    ) {
      return 110;
    } else if (propName === "") {
      return 130;
    } else if (propName.includes("Amount") || propName === "emailConfirmed") {
      return 150;
    } else if (propName === "documentNumber") {
      return 165;
    } else if (propName === "ticketStatus") {
      return 150;
    }  else {
      return null;
    }
  };

  keyList.map((key) => {
    let propName = key.includes("Name") && key !== "companyName" ? "name" : key;
    let columnItem = {
      label: CreateColumnName(key),
      prop: propName,
      filters: getFilters(keyValuePairs, propName, type),
      filterable: isFilterable(keyValuePairs, propName, type),
      filterType: getFilterType(propName),
      sortable:
        propName === "edit" ||
        propName === "delete" ||
        (propName === "name" && type === "automaticPaymentList") ||
        (propName === "name" && type === "invoiceExtract")
          ? false
          : true,
      width: setWidth(propName, type),
    };
    return columns.push(columnItem);
  });

  return columns;
};

export default createTableColumns;



// WEBPACK FOOTER //
// ./src/helpers/createTableColumns.js